import React from 'react';

import { Trans } from '@lyearn/i18n';
import { AddMenuVideo, StarAiFill, VideoOutline } from '@lyearn/icons';
import { AllowForwardingDownloading, isAdvancedItemEnabled } from '@lyearn/lygo-blocks';
import { addMenuItemType, createReactExtension, PerformanceType } from '@lyearn/lygo-core';
import { Box } from '@lyearn/ui';

const aiVideoGenerationExtension = createReactExtension({
  name: 'ly__ai_video',
  attrs: {
    src: {
      default: null,
    },
    file: {
      default: null,
    },
    caption: {
      default: null,
    },
    width: {
      default: null,
    },
    name: {
      default: null,
    },
    allowForwarding: {
      default: true,
    },
    allowPlaybackSpeedControl: {
      default: false,
    },
    allowDownloading: {
      default: false,
    },
    captions: {
      default: null,
    },
    disabedCaptions: {
      default: null,
    },
    sections: {
      default: null,
    },
    downloadableUrl: {
      default: null,
    },
    thumbnail: {
      default: null,
    },
    allowBackgroundVideoPlayback: {
      default: false,
    },
    generativeTaskId: {
      default: null,
    },
    slides: {
      default: null,
    },
    videoScript: {
      default: null,
    },
    avatarId: {
      default: null,
    },
    voiceId: {
      default: null,
    },
    videoType: {
      default: 'avatarNarration',
    },
    hasInitialized: {
      default: false,
    },
    slideDeckUrl: {
      default: null,
    },
    slideDeckFileName: {
      default: null,
    },
    slideDeckFileSummary: {
      default: null,
    },
  },
  Component: (props) => {
    const Component = require('./GenerateVideo').default;
    return (
      <Box className="mt-24">
        <Component {...props} />
      </Box>
    );
  },
  menuItem: [
    {
      name: 'ly__ai_video',
      title: (
        <span className="inline-flex items-center gap-6">
          <Trans i18nKey="Lygo:Menu.aiVideo.title" />
          <span className="inline-flex items-center gap-2 rounded-full bg-[#EEF0FF] px-6 py-1">
            <StarAiFill className="text-[#5B50E8]" height={10} width={10} />
            <span className="text-[10px] font-medium text-[#5B50E8]">New</span>
          </span>
        </span>
      ),
      description: <Trans i18nKey="Lygo:Menu.aiVideo.description" />,
      icon: VideoOutline,
      addMenuIcon: AddMenuVideo,
      addMenuItemType: addMenuItemType.media,
      searchWords: ['video', 'media', 'ai', 'generate', 'aivideo'],
      isText: false,
      attrs: {
        src: null,
        width: 75,
        generativeTaskId: null,
        contentId: null,
        avatarId: null,
        voiceId: null,
        videoType: 'avatarNarration',
        videoScript: null,
        slides: null,
        hasInitialized: false,
        slideDeckUrl: null,
        slideDeckFileName: null,
        slideDeckFileSummary: null,
      },
    },
  ],
  advancedMenuItem: {
    name: 'ly__ai_video',
    title: 'AI Video Settings',
    components: [
      {
        name: 'allow_forwarding',
        component: (props) => (
          <AllowForwardingDownloading showDownload showPlaybackSpeedControls {...props} />
        ),
        isEnabled: isAdvancedItemEnabled,
      },
    ],
  },
  performanceType: PerformanceType.BLOCK_BASED,
});

export default aiVideoGenerationExtension;
